import React, { useState, useEffect, useContext } from "react";
import "./personalDetails.css";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/successImg.png";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import { useFormik } from "formik";
// import { axiosInstance } from "../../axiosInstance";
import { object, string } from "yup";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import * as Yup from "yup";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
// const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

const PersonalSchema = Yup.object().shape({
  profile: Yup.mixed().test(
    "is-valid-profile",
    "You can only upload up to 5 images",
    (value) => {
      if (!value) return true;
      if (typeof value === "string") return true; // Allow string URLs
      if (Array.isArray(value)) return value.length <= 5;
      return false;
    }
  ),
  caste: Yup.number()
    .typeError("Select Caste") // for handling empty string
    .required("Select Caste"),
});

export function PersonalDetails() {
  const { language } = useContext(LanguageContext);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [religion, setReligion] = useState([]);
  const [religionId, setReligionId] = useState();
  const [casteId, setCasteId] = useState();
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubCaste] = useState([]);
  const [matchedReligionId, setMatchedReligionId] = useState(null);
  const [motherTongue, setMotherTongue] = useState([]);

  const [fileNames, setFileNames] = useState("Browse");
  const [imagePreviews, setImagePreviews] = useState([]);

  const params = useParams();
  const userid = params.id;

  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [profileImgPreview, setProfileImgPreview] = useState([]);

  const formik = useFormik({
    initialValues: {
      profile: [],
      name: "",
      gender: "",
      dob: "",
      tob: "",
      pob: "",
      rashi: "",
      nakshatra: "",
      height: "",
      marital_status: "",
      religion: "",
      mother_tongue: "",
      caste: "",
      sub_caste: "",
      gotra: "",
      manglik: "",
      education: "",
      college_name: "",
      employed_in: "",
      organization_name: "",
      annual_income: "",
    },
    validationSchema: PersonalSchema,
    onSubmit: async (values) => {
      try {
        // getting id on user select so converting id into name
        const selectedReligion = religion.find(
          (r) => r.id === Number(values.religion)
        );
        const selectedCaste = caste.find((c) => c.id === Number(values.caste));
        const selectedSubCaste = subcaste.find(
          (s) => s.id === Number(values.sub_caste)
        );
        const selectedMotherTongue = motherTongue.find(
          (m) => m.id === Number(values.mother_tongue)
        );
        const formData = new FormData();

        formData.append("name", values.name);
        formData.append("gender", values.gender);
        formData.append("dob", values.dob);
        formData.append("tob", values.tob);
        formData.append("pob", values.pob);
        formData.append("rashi", values.rashi);
        formData.append("nakshatra", values.nakshatra);
        formData.append("height", values.height);
        formData.append("marital_status", values.marital_status);
        formData.append("religion", selectedReligion?.name || "");
        formData.append("mother_tongue", selectedMotherTongue?.name || "");
        formData.append("caste", selectedCaste?.name || "");
        formData.append("sub_caste", selectedSubCaste?.name || "");
        formData.append("gotra", values.gotra);
        formData.append("manglik", values.manglik);
        formData.append("education", values.education);
        formData.append("college_name", values.college_name);
        formData.append("employed_in", values.employed_in);
        formData.append("organization_name", values.organization_name);
        formData.append("annual_income", values.annual_income);

        // Append file only if selected
        // if (selectedProfileFile) {
        //   formData.append("profile", selectedProfileFile);
        // }
        if (selectedProfileFile && selectedProfileFile.length > 0) {
          selectedProfileFile.forEach((file) => {
            formData.append("profile", file);
          });
        }

        const response = await axiosInstance.patch(
          `biodata/${userid}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === true) {
          toast.success(response.data.message || "Updated Successfully!");
          handleOpen();
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }
    },
  });

  async function LoadUser(id) {
    try {
      const response = await axiosInstance.get(`biodata/${id}`);
      const { data } = response.data;
      console.log("Edited User", data);

      if (data) {
        const matchedReligion = religion.find((r) => r.name === data.religion);
        const religionId = matchedReligion ? matchedReligion.id : null;
        console.log("matchedReligionId", religionId);

        setMatchedReligionId(religionId); // <-- set the religion ID here

        // Match mother tongue
        const matchedMotherTongue = motherTongue.find(
          (m) => m.name === data.mother_tongue
        );
        const motherTongueId = matchedMotherTongue
          ? matchedMotherTongue.id
          : "";

        // destructure and set form values as before
        formik.setValues({
          profile: typeof data.profile === "string" ? [data.profile] : [],
          name: data.name || "",
          gender: data.gender || "",
          dob: data.dob || "",
          tob: data.tob || "",
          pob: data.pob || "",
          rashi: data.rashi || "",
          nakshatra: data.nakshatra || "",
          height: data.height ? parseFloat(data.height).toFixed(1) : "",
          marital_status: data.marital_status || "",
          religion: religionId || "",
          mother_tongue: motherTongueId,
          caste: data.caste || "",
          sub_caste: data.sub_caste || "",
          gotra: data.gotra || "",
          manglik: data.manglik || "",
          education: data.education || "",
          college_name: data.college_name || "",
          employed_in: data.employed_in || "",
          organization_name: data.organization_name || "",
          annual_income: data.annual_income || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }
  useEffect(() => {
    if (matchedReligionId) {
      LoadCaste(matchedReligionId);
    }
  }, [matchedReligionId]);

  useEffect(() => {
    if (religion.length > 0 && params.id) {
      LoadUser(params.id);
    }
  }, [religion, params.id]);

  async function LoadReligion() {
    try {
      const response = await axios.get(
        "https://devapi.naticharami.in/api/v1/dropdown/choices"
        // "https://api.naticharami.in/api/v1/dropdown/choices"
      );

      if (response.status === 200 && response.data) {
        console.log("religion", response.data.religion);
        setReligion(response.data.religion);
        setMotherTongue(response.data.mother_tongue);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }

  // async function LoadCaste(religionId) {
  //   const response = await axios.get(
  //     `https://devapi.naticharami.in/api/v1/dropdown/caste/${religionId}`
  //   );
  //   const data = response.data;
  //   console.log("caste", data);
  //   setCaste(data);
  // }

  async function LoadCaste(matchedReligionId) {
    try {
      const response = await axios.get(
        `https://devapi.naticharami.in/api/v1/dropdown/caste/${matchedReligionId}`
        // `https://api.naticharami.in/api/v1/dropdown/caste/${matchedReligionId}`
      );
      const data = response.data;
      console.log("caste", data);
      setCaste(data);
    } catch (error) {
      console.error("Error loading caste list", error);
    }
  }

  useEffect(() => {
    LoadReligion();
  }, []);

  useEffect(() => {
    if (religionId) {
      LoadCaste(religionId);
    }
  }, [religionId]);

  async function LoadSubCaste(casteId) {
    const response = await axios.get(
      // `https://devapi.naticharami.in/api/v1/dropdown/sub-caste/${casteId}`
      `https://api.naticharami.in/api/v1/dropdown/sub-caste/${casteId}`
    );
    const data = response.data;
    console.log("subcaste", data);
    setSubCaste(data);
  }
  useEffect(() => {
    if (casteId) {
      LoadSubCaste(casteId);
    }
  }, [casteId]);

  return (
    <>
      {/* <ToastContainer/> */}
      <form onSubmit={formik.handleSubmit}>
        <div className="basicMainContainer">
          <div>
            {/* row 0 */}
            <div className="basicSubcontainer">
              {/* <div>
            <div className="lableName">
              Upload Photo: <span className="text-danger">*</span>
            </div>
            <div className="basicTextbox">
              <input type="file" style={{ padding: "7px" }}></input> Max size 5
              MB per image
            </div>
          </div> */}
              <div>
                <div className="lableName">
                  {translations[language].upload_photo}{" "}
                </div>
                {/* <label for="fileInput" className="custom-file-label " >
              {fileNames}
            </label> */}

                {/* <input
              type="file"
              id="fileInput"
              class="custom-file-input"
              accept="image/*"
              multiple
              onChange={handleFileChange}
            /> */}
                <div className="basicTextbox">
                  <input
                    type="file"
                    multiple
                    style={{ padding: "7px" }}
                    id="profile"
                    name="profile"
                    accept="image/*"
                    // onChange={(e) => {
                    //   const files = Array.from(e.target.files);
                    //   if (files.length > 0) {
                    //     const imageUrls = files.map((file) =>
                    //       URL.createObjectURL(file)
                    //     );
                    //     setProfileImgPreview(imageUrls);
                    //     setSelectedProfileFile(files);
                    //   }
                    // }}
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      if (files.length > 0) {
                        const imageUrls = files.map((file) =>
                          URL.createObjectURL(file)
                        );
                        setProfileImgPreview(imageUrls);
                        setSelectedProfileFile(files);
                        formik.setFieldValue("profile", files);
                      } else {
                        formik.setFieldValue("profile", null);
                      }
                    }}
                    className={
                      formik.touched.profile && formik.errors.profile
                        ? "error"
                        : ""
                    }
                  ></input>{" "}
                </div>
                <div className="wallet-label">Can add upto 5 images</div>
                <div>
                  {formik.touched.profile && formik.errors.profile && (
                    <div className="text-danger">{formik.errors.profile}</div>
                  )}
                </div>
                <div className="image-preview-container">
                  {profileImgPreview.map((src, index) => (
                    <img
                      key={index}
                      src={src}
                      alt={`Preview ${index}`}
                      className="image-preview"
                    />
                  ))}
                </div>
              </div>
              {/* <div
                className="form-check form-switch d-flex align-items-center"
                style={{ marginLeft: "-35px" }}
              >
                <label
                  className="form-check-label lableName"
                  htmlFor="blurSwitch"
                >
                  {translations[language].blur_image}
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="blurSwitch"
                  style={{
                    marginTop: "10px",
                    fontSize: "25px",
                    marginLeft: "20px",
                  }}
                />
              </div> */}
            </div>
            {/* row1 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].full_name}{" "}
                </div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    className={
                      formik.touched.name && formik.errors.name ? "error" : ""
                    }
                  ></input>
                  <div>
                    {formik.touched.name && formik.errors.name && (
                      <div className="text-danger">{formik.errors.name}</div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].gender}{" "}
                </div>

                <div>
                  <select
                    name="gender"
                    value={formik.values.gender}
                    onChange={formik.handleChange}
                    className={`dropdown-btnBasic ${
                      formik.touched.gender && formik.errors.gender
                        ? "error"
                        : ""
                    }`}
                  >
                    <option>Select</option>
                    <option>Female</option>
                    <option>Male</option>
                  </select>
                  <div>
                    {formik.touched.gender && formik.errors.gender && (
                      <div className="text-danger">{formik.errors.gender}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* row2 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">{translations[language].dob}</div>
                <div className="basicTextbox">
                  <input
                    type="date"
                    id="dob"
                    onChange={formik.handleChange}
                    value={formik.values.dob}
                    max={new Date().toISOString().split("T")[0]}
                    className={
                      formik.touched.dob && formik.errors.dob ? "error" : ""
                    }
                  ></input>
                  <div>
                    {formik.touched.dob && formik.errors.dob && (
                      <div className="text-danger">{formik.errors.dob}</div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName"> {translations[language].tob}</div>
                <div className="basicTextbox">
                  <input
                    type="time"
                    step="1" // enables seconds
                    id="tob"
                    onChange={formik.handleChange}
                    value={formik.values.tob}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.tob && formik.errors.tob ? "error" : ""
                    }
                  />
                  <div>
                    {formik.touched.tob && formik.errors.tob && (
                      <div className="text-danger">{formik.errors.tob}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* row3 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">{translations[language].pob} </div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="pob"
                    onChange={formik.handleChange}
                    value={formik.values.pob}
                    className={
                      formik.touched.pob && formik.errors.pob ? "error" : ""
                    }
                  ></input>
                  <div>
                    {formik.touched.pob && formik.errors.pob && (
                      <div className="text-danger">{formik.errors.pob}</div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">{translations[language].rashi}</div>
                <div>
                  <div className="basicTextbox">
                    <select
                      name="rashi"
                      id="rashi"
                      value={formik.values.rashi}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.rashi && formik.errors.rashi
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Rashi
                      </option>
                      <option>Mesham</option>
                      <option>Vrushabham</option>
                      <option>Midhunam</option>
                      <option>Karkatakam</option>
                      <option>Simham</option>
                      <option>Kanya</option>
                      <option>Tula</option>
                      <option>Vruschikam</option>
                      <option>Dhanussu</option>
                      <option>Makaram</option>
                      <option>Kumbham</option>
                      <option>Meenam</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* row4 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].nakshatra}
                </div>
                <div>
                  <div className="basicTextbox">
                    <select
                      name="nakshatra"
                      id="nakshatra"
                      value={formik.values.nakshatra}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.nakshatra && formik.errors.nakshatra
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Nakshatra
                      </option>
                      <option>Anuraadha</option>
                      <option>Arudra</option>
                      <option>Ashlesha</option>
                      <option>Ashwini</option>
                      <option>Bharani</option>
                      <option>Chittaa</option>
                      <option>Dhanishta</option>
                      <option>Asthami</option>
                      <option>Jyesthaa</option>
                      <option> Kritika</option>
                      <option> Maghaa</option>
                      <option>Mula</option>
                      <option> Mrigasiraa</option>
                      <option>Punarvasu</option>
                      <option>Poorvashaadha</option>
                      <option> Poorvabhadraa</option>
                      <option>Pubba</option>
                      <option>Pushya</option>
                      <option> Revati</option>
                      <option>Rohini</option>
                      <option>Shatabhisha</option>
                      <option>Shravana</option>
                      <option>Swaati</option>
                      <option>Uttarashaadha</option>
                      <option> Uttaraa bhadra</option>
                      <option>Uttara</option>
                      <option>Vishaakha</option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].height}{" "}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
                
                <option>Select</option>
                <option>--</option>
              </select> */}
                  <div className="basicTextbox">
                    <select
                      name="height"
                      id="height"
                      value={formik.values.height}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.height && formik.errors.height
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Height
                      </option>
                      <option value="4.0">4.0</option>
                      <option value="4.1">4.1</option>
                      <option value="4.2">4.2</option>
                      <option value="4.3">4.3</option>
                      <option value="4.4">4.4 </option>
                      <option value="4.5">4.5 </option>
                      <option value="4.6">4.6</option>
                      <option value="4.7">4.7 </option>
                      <option value="4.8">4.8 </option>
                      <option value="4.9">4.9 </option>
                      <option value="4.10">4.10</option>
                      <option value="4.11">4.11</option>
                      <option value="5.0">5.0 </option>
                      <option value="5.1">5.1 </option>
                      <option value="5.2">5.2 </option>
                      <option value="5.3">5.3 </option>
                      <option value="5.4">5.4 </option>
                      <option value="5.5">5.5 </option>
                      <option value="5.6">5.6 </option>
                      <option value="5.7">5.7 </option>
                      <option value="5.8">5.8 </option>
                      <option value="5.9">5.9 </option>
                      <option value="5.10">5.10 </option>
                      <option value="5.11">5.11 </option>
                      <option value="6.0">6.0 </option>
                      <option value="6.1">6.1 </option>
                      <option value="6.2">6.2 </option>
                      <option value="6.3">6.3 </option>
                      <option value="6.4">6.4 </option>
                      <option value="6.5">6.5 </option>
                      <option value="6.6">6.6 </option>
                      <option value="6.7">6.7 </option>
                      <option value="6.8">6.8 </option>
                      <option value="6.9">6.9 </option>
                      <option value="6.10">6.10</option>
                      <option value="6.11">6.11</option>
                      <option value="7.0">7.0 </option>
                      <option value="7.1">7.1 </option>
                      <option value="7.2">7.2 </option>
                      <option value="7.3">7.3 </option>
                      <option value="7.4">7.4 </option>
                      <option value="7.5">7.5 </option>
                      <option value="7.6">7.6 </option>
                      <option value="7.7">7.7 </option>
                      <option value="7.8">7.8 </option>
                      <option value="7.9">7.9 </option>
                      <option value="7.10">7.10 </option>
                      <option value="7.11">7.11 </option>
                    </select>
                    <div>
                      {formik.touched.height && formik.errors.height && (
                        <div className="text-danger">
                          {formik.errors.height}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row5 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].marital_status}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic"
              name="marital_status"
              onChange={formik.handleChange}
              value={formik.values.marital_status}
              >
               
                <option>Select</option>
                <option>---</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="marital_status"
                      onChange={formik.handleChange}
                      value={formik.values.marital_status}
                    ></input>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].religion}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
                
                <option>Select</option>
                <option>---</option>
              </select> */}
                  <div className="basicTextbox">
                    <select
                      name="religion"
                      id="religion"
                      value={formik.values.religion}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        formik.setFieldValue("religion", selectedId);
                        setReligionId(selectedId);
                        console.log("Selected Religion ID:", selectedId);
                      }}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.religion && formik.errors.religion
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Religion
                      </option>
                      {religion.map((list) => (
                        <option value={list.id} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>
                    <div>
                      {formik.touched.religion && formik.errors.religion && (
                        <div className="text-danger">
                          {formik.errors.religion}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row6 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].mother_tougue}{" "}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
             
                <option>Select</option>
                <option>type 1</option>
                <option>type 2</option>
              </select> */}
                  <div className="basicTextbox">
                    <select
                      name="mother_tongue"
                      id="mother_tongue"
                      value={formik.values.mother_tongue}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.mother_tongue &&
                        formik.errors.mother_tongue
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="">Select Mother Tongue</option>
                      {motherTongue.map((list) => (
                        <option value={list.id} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>
                    <div>
                      {formik.touched.mother_tongue &&
                        formik.errors.mother_tongue && (
                          <div className="text-danger">
                            {formik.errors.mother_tongue}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">{translations[language].caste} </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
              
                <option>Select</option>
                <option>type 2</option>
              </select> */}
                  <div className="basicTextbox">
                    {/* <input
                      type="text"
                      id="caste"
                      onChange={formik.handleChange}
                      value={formik.values.caste}
                    ></input> */}
                    <select
                      name="caste"
                      id="caste"
                      value={formik.values.caste}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        formik.setFieldValue("caste", selectedId);
                        setCasteId(selectedId);
                        console.log("Selected Caste ID:", selectedId);
                      }}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.caste && formik.errors.caste
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="">Select Caste</option>
                      {caste.map((list) => (
                        <option value={list.id} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>
                    {/* <div className="text-danger">Select Caste</div> */}
                    <div className="text-danger">
                      {formik.touched.caste && formik.errors.caste && (
                        <div className="error">{formik.errors.caste}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row7 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].subcaste}
                </div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    placeholder="Enter sub caste"
                    id="sub_caste"
                    onChange={formik.handleChange}
                    value={formik.values.sub_caste}
                  ></input> */}
                  <select
                    name="sub_caste"
                    id="sub_caste"
                    value={formik.values.sub_caste}
                    // onChange={(e) => {
                    //   const selectedId = e.target.value;
                    //   formik.setFieldValue("caste", selectedId);
                    //   setCasteId(selectedId);
                    //   console.log("Selected SubCaste ID:", selectedId);
                    // }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.caste && formik.errors.caste ? "error" : ""
                    }`}
                  >
                    <option value="">Select Sub Caste</option>
                    {subcaste.map((list) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>
                  <div>First Select Caste</div>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].gothram}
                </div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    placeholder="Enter Gothram"
                    id="gotra"
                    onChange={formik.handleChange}
                    value={formik.values.gotra}
                  ></input>
                </div>
              </div>
            </div>

            {/* row8 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].manglik}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
               
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="manglik"
                      onChange={formik.handleChange}
                      value={formik.values.manglik}
                      placeholder="Enter Manglik"
                    ></input>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].education}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
            
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="education"
                      onChange={formik.handleChange}
                      value={formik.values.education}
                      placeholder="Enter Education"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            {/* row9 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].college_name}
                </div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    placeholder="Enter College name"
                    id="college_name"
                    value={formik.values.college_name}
                    onChange={formik.handleChange}
                  ></input>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].employed_in}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
               
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="employed_in"
                      onChange={formik.handleChange}
                      value={formik.values.employed_in}
                      placeholder="Enter Employee Designation"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            {/* row10 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">
                  {translations[language].organization_name}
                </div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    placeholder="Enter Organization name"
                    value={formik.values.organization_name}
                    onChange={formik.handleChange}
                    id="organization_name"
                  ></input>
                </div>
              </div>
              <div>
                <div className="lableName">
                  {translations[language].annual_income}
                </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
            
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="annual_income"
                      onChange={formik.handleChange}
                      value={formik.values.annual_income}
                      placeholder="Enter Annual Income"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="btnBasicSave">
              <Button type="submit">{translations[language].btnSave}</Button>
              {/* <Button onClick={handleOpen} type="submit">Save Changes</Button> */}
            </div>

            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose} //close modal on background click
              closeAfterTransition
            >
              <Fade in={open}>
                <Box sx={style} className="modal-box">
                  <img srcSet={successImg} />
                  <Typography
                    id="transition-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Thank You
                  </Typography>
                  <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                    The profile has been successfully updated
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </div>
        </div>
      </form>
    </>
  );
}
